import React from "react";
import { FiAlertTriangle, FiCheckCircle, FiInfo } from "react-icons/fi";

const StatusBadge = ({ value, type = "severity" }) => {
  if (!value) return null;

  if (type === "severity") {
    const v = String(value);
    if (v.toUpperCase() === "HIGH" || v === "High") {
      return (
        <span className="em-badge em-badge--high">
          <FiAlertTriangle /> High
        </span>
      );
    }
    if (v.toUpperCase() === "MEDIUM" || v === "Medium") {
      return (
        <span className="em-badge em-badge--medium">
          <FiInfo /> Medium
        </span>
      );
    }
    if (v.toUpperCase() === "LOW" || v === "Low") {
      return (
        <span className="em-badge em-badge--low">
          <FiCheckCircle /> Low
        </span>
      );
    }
    if (v.toUpperCase() === 'RESOLVED') {
      return (
        <span className="em-badge em-badge--low">
          <FiCheckCircle /> Resolved
        </span>
      )
    }
  }

  return <span className="em-badge em-badge--status">{value}</span>;
};

export default StatusBadge;

